import React from 'react'
import * as R from 'remeda'

import { intersectionBy } from '~/utils'

import { useCurrentSurveyGroup } from './useCurrentSurveyGroup'
import { useMainQuerySurveys } from './useMainQuery'

export const useCurrentSurveys = () => {
  const surveys = useMainQuerySurveys()
  const surveyGroup = useCurrentSurveyGroup()

  return React.useMemo(
    () =>
      intersectionBy(surveys, surveyGroup.surveys, R.prop('id'), R.prop('id')),
    [surveyGroup.surveys, surveys],
  )
}
